"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveHearabout = exports.ordinals = exports.languagesSorted = exports.getWeekString = exports.getScheduledPaymentsFromOrder = exports.getPaidAmount = exports.getLeftToPay = exports.getGrossDue = exports.getDeadlinesWithStatus = exports.getCountryName = exports.countriesSorted = exports.addBookingComment = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _countriesList = require("countries-list");
var _moment = _interopRequireDefault(require("moment"));
var _week = require("./week");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ordinals = exports.ordinals = {
  1: '1st',
  2: '2nd',
  3: '3rd'
};

/**
 * Returns an array of countries and their 2 letter ISO codes, sorted alphabetically by country name
 * @type {{code: string, name: string}[]}
 */
var countriesSorted = exports.countriesSorted = Object.entries(_countriesList.countries).map(function (_ref) {
  var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
    countryCode = _ref2[0],
    countryData = _ref2[1];
  return {
    code: countryCode,
    name: countryData.name
  };
}).sort(function (a, b) {
  return a.name > b.name ? 1 : -1;
});
var getCountryName = exports.getCountryName = function getCountryName(countryCode) {
  return _countriesList.countries[countryCode.toUpperCase()].name;
};
var languagesSorted = exports.languagesSorted = Object.entries(_countriesList.languages).map(function (_ref3) {
  var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
    countryCode = _ref4[0],
    countryData = _ref4[1];
  return {
    code: countryCode,
    name: countryData.name
  };
}).sort(function (a, b) {
  return a.name > b.name ? 1 : -1;
});
var addBookingComment = exports.addBookingComment = function addBookingComment(bookingId, text) {
  return fetch("/api/booking/".concat(bookingId, "/add-comment"), {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({
      text: text
    })
  });
};
var saveHearabout = exports.saveHearabout = function saveHearabout(bookingId, hearabout, comment) {
  return fetch("/api/booking/".concat(bookingId, "/update-hearabout"), {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({
      hearabout: hearabout,
      comment: comment
    })
  });
};
var getPaidAmount = exports.getPaidAmount = function getPaidAmount(order) {
  var paid = 0;
  if (order) {
    paid = order.payments.reduce(function (sum, p) {
      return sum + (p.status === 'paid' ? p.amountRegistered : 0);
    }, 0);
  }
  return paid;
};
var getDeadlinesWithStatus = exports.getDeadlinesWithStatus = function getDeadlinesWithStatus(order) {
  var deadlines = order.orderDeadlines;
  deadlines.sort(function (a, b) {
    return new Date(a.dueDate) - new Date(b.dueDate);
  });
  if (deadlines.length === 0) {
    deadlines.push({
      dueDate: order.dueDate,
      amount: order.gross
    });
  }
  var paidAmount = getPaidAmount(order);
  var deadlineSum = 0;
  return deadlines.map(function (deadline, i) {
    deadlineSum += deadline.amount;
    var paid = paidAmount >= deadlineSum;
    var overdue = !paid && (0, _moment["default"])(deadline.dueDate).isBefore();
    var status = 'pending';
    if (paid) {
      status = 'paid';
    } else if (overdue) {
      status = 'overdue';
    }
    return _objectSpread(_objectSpread({}, deadline), {}, {
      status: status,
      name: ordinals[i + 1]
    });
  });
};
var getGrossDue = exports.getGrossDue = function getGrossDue(order) {
  var paidAmount = getPaidAmount(order);
  return order.gross - paidAmount;
};

/**
 * gets the current scheduled payments from the mainorder
 * @param {} mainOrder
 * @return [] scheduledpayments
 */
var getScheduledPaymentsFromOrder = exports.getScheduledPaymentsFromOrder = function getScheduledPaymentsFromOrder(mainOrder) {
  var minAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  if (!mainOrder.payments || mainOrder.payments.length < 1) {
    return null;
  }
  var scheduledPayments = [];
  var scheduled = mainOrder.payments.filter(function (payment) {
    return payment.status === "scheduled";
  });
  var amountToReduce = minAmount / scheduled.length;
  scheduled.forEach(function (payment) {
    scheduledPayments.push({
      amount: payment.amountRegistered - amountToReduce,
      dateScheduled: payment.dateScheduled
    });
  });
  return scheduledPayments;
};

/**
 * This crazy calculation returns the overdue amount and duedate
 * or the upcoming deadline and missing amount
 * @param  {} order [description]
 * @return {leftToPay, nextDueDate} amount and dueDate
 */
var getLeftToPay = exports.getLeftToPay = function getLeftToPay(order) {
  var paidAmount = getPaidAmount(order);
  var leftToPay = getGrossDue(order);
  var hasScheduledPayments = order.payments.some(function (payment) {
    return payment.status === 'scheduled';
  });
  var nextDueDate;
  var deadlineSum = 0;
  var overdueAmount = 0;
  var overdueDuedate;
  if (hasScheduledPayments) {
    // calculate amount to pay off next scheduled payment
    var nextScheduledPayment = order.payments.find(function (payment) {
      return payment.status === 'scheduled';
    });
    overdueDuedate = nextScheduledPayment.dateScheduled;
    overdueAmount = nextScheduledPayment.amountRegistered;
  } else {
    // use normal order deadlines logic
    for (var i = 0; i < order.orderDeadlines.length; i += 1) {
      var deadline = order.orderDeadlines[i];
      deadlineSum += deadline.amount;
      var diff = deadlineSum - paidAmount;
      if (diff > 0) {
        if ((0, _moment["default"])(deadline.dueDate).isBefore()) {
          overdueAmount = diff;
          overdueDuedate = deadline.dueDate;
        }
        if (!nextDueDate) {
          nextDueDate = deadline.dueDate;
          leftToPay = diff;
        }
      }
    }
  }
  if (overdueAmount > 0) {
    leftToPay = overdueAmount;
    nextDueDate = overdueDuedate;
  }
  nextDueDate = nextDueDate || order.dueDate;
  return {
    leftToPay: leftToPay,
    nextDueDate: nextDueDate
  };
};
var getWeekString = exports.getWeekString = function getWeekString(week) {
  var beginDate = _moment["default"].utc((0, _week.getGuestDates)(week).beginDate);
  var endDate = _moment["default"].utc((0, _week.getGuestDates)(week).endDate);
  var isSameMonth = beginDate.isSame(endDate, 'month');
  return "".concat(beginDate.format("".concat(isSameMonth ? 'DD' : 'DD MMM')), "\n        -\n        ").concat(endDate.format('DD MMM YYYY'));
};